import React from 'react';
import MainPageCompenent from '../MainPageCompenent';
import Wheel from './Wheel';

function WheelContainer(props) {
    return (
        <MainPageCompenent>
            <Wheel />
        </MainPageCompenent>
    );
}

export default WheelContainer;